import React from 'react';
import { Edit3, History, AlertCircle } from 'lucide-react';

const VersionIndicator = ({ 
  section, 
  currentVersion, 
  hasBeenEdited, 
  onShowHistory,
  className = "" 
}) => {
  if (!hasBeenEdited) return null;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
        <Edit3 className="w-3 h-3" />
        <span>v{currentVersion}</span>
      </div>
      
      {onShowHistory && (
        <button
          onClick={() => onShowHistory(section)}
          className="flex items-center gap-1 px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs hover:bg-gray-200 transition-colors"
          title="View feedback history"
        >
          <History className="w-3 h-3" />
          <span>History</span>
        </button>
      )}
    </div>
  );
};

export default VersionIndicator;
